export default class LoadSvg {
  constructor() {
    this.arrowSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="18.414" height="12.398" viewBox="0 0 18.414 12.398">\n' +
      '                    <g id="Gruppe_7138" data-name="Gruppe 7138" transform="translate(-1763 -1348.801)">\n' +
      '                      <path id="Pfad_21455" data-name="Pfad 21455" d="M.354.354,5.846,5.846.354,11.338" transform="translate(1774.154 1349.155)" fill="none" stroke="unset" stroke-miterlimit="10" stroke-width="2"></path>\n' +
      '                      <path id="Pfad_21668" data-name="Pfad 21668" d="M17,0H0" transform="translate(1763 1355)" fill="#2a3640" stroke="unset" stroke-width="2">\n' +
      "                      </path>\n" +
      "                    </g>\n" +
      "                  </svg>";

    this.closeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16.302" height="16.302" viewBox="0 0 16.302 16.302"><g id="Gruppe_8402" data-name="Gruppe 8402" transform="translate(6837.914 -13771.086)"><line id="Linie_720" data-name="Linie 720" x2="13.474" y2="13.474" transform="translate(-6836.5 13772.5)" fill="none" stroke-linecap="round" stroke-width="2"></line><line id="Linie_721" data-name="Linie 721" x1="13.474" y2="13.474" transform="translate(-6836.5 13772.5)" fill="none" stroke-linecap="round" stroke-width="2"></line></g></svg>';

    this.loadArrowButton();
    this.loadSvg();
    this.loadButtonSvg();
  }

  loadButtonSvg() {
    const buttons = document.querySelectorAll("[data-load-svg]");
    buttons.forEach((button) => {
      const type = button.getAttribute("data-load-svg");
      if (type === "arrow")
        button.innerHTML = "<figure>" + this.arrowSvg + "</figure>";
      if (type === "close")
        button.innerHTML =
          button.innerHTML + "<figure>" + this.closeSvg + "</figure>";
    });
  }

  loadArrowButton() {
    const buttons = document.querySelectorAll(".o-button--arrow.o-button--rte");

    buttons.forEach((button) => {
      let text = "<span>" + button.innerText + "</span>";
      button.innerHTML = this.arrowSvg + text;
    });
  }

  loadSvg() {
    let figures = document.querySelectorAll("figure:has(img)");
    let sortFigures = [];

    figures.forEach((figure) => {
      const img = figure.querySelector("img");
      figure.id = "id" + Math.random().toString(16).slice(2);

      const src = img.getAttribute("src");
      if (src?.includes(".svg")) sortFigures.push(figure);
    });

    sortFigures.forEach((figure) => {
      const img = figure.querySelector("img");
      const src = img.getAttribute("src");
      $("#" + figure.id).load(src);
    });
  }
}
